<template>
  <div>
    <main class="authenticationPageLayout">
      <div class="main_page_frame">
        <div class="pageClose dialogDismiss">
          <router-link :to="{name: 'signuplander'}" class="close_dialog cls_lg"></router-link>
        </div>
        <div class="section_block">
          <div class="container content_narrow">
            <div class="authblock">
              <div class="row no-gutters">
                <aside class="authSidePanel col-sm-5 col-md-5">
                  <div class="panelWrapper">
                    <div class="LogoHolder">
                      <router-link :to="{ name: 'home'}">
                        <img :src="`${$baseImageUrl}/logo.svg`" alt="Gradely.ng" />
                      </router-link>
                    </div>
                    <signup-options />
                    <p class="font-md">
                      Farmzone is a social venture, whose aim
                      is to connect the farm to the market.
                    </p>
                  </div>
                </aside>
                <section class="authFormHolder col-sm-7 col-md-7">
                  <div class="panelWrapper">
                    <div class="blockHeader">
                      <h3 class="title title_md font-bold">Off-taker account</h3>
                      <p class="font-md">
                        Already have an account?
                        <router-link :to="{ name: 'login' }" class="btn-link font-bold">Log in</router-link>
                      </p>
                    </div>
                    <!-- Show this when there is an error -->
                    <div class="error_message hidden">
                      <p>Something went wrong. Please try again in a moment.</p>
                    </div>
                    <form action="#" @submit.prevent="signup">
                      <!-- <div class="form-group">
                                                <div class="labeledInputBlock">
                                                    <label for="us_fname" class="control-label color__default">Your Name</label>
                                                    <input type="text" class="form-control" id="us_fname" placeholder="E.g. Adeyemi Mathew">
                                                </div>
                      </div>-->
                      <div class="row">
                        <div class="form-group col-sm-6">
                          <div class="labeledInputBlock">
                            <label
                              for="us_fname"
                              class="control-label color__default requiredField"
                            >
                              First
                              Name
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              v-alpha-input
                              id="us_fname"
                              placeholder="E.g. Adeyemi"
                              v-model="formData.firstName"
                            />
                          </div>
                        </div>
                        <div class="form-group col-sm-6">
                          <div class="labeledInputBlock">
                            <label
                              for="us_lname"
                              class="control-label color__default requiredField"
                            >
                              Last
                              Name
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              v-alpha-input
                              id="us_lname"
                              placeholder="E.g. Mathew"
                              v-model="formData.lastName"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="labeledInputBlock">
                          <label for="us_bname" class="control-label color__default">
                            Organization
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="us_bname"
                            v-model="formData.orgName"
                            placeholder="Enter the name of your Organization or Business"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="labeledInputBlock">
                          <label for="us_email" class="control-label color__default requiredField">
                            Email
                            Address
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            v-model="formData.email"
                            id="us_email"
                            placeholder="Enter your email address"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="labeledInputBlock">
                          <label for="us_phone" class="control-label color__default requiredField">
                            Phone
                            Number
                          </label>
                          <div class>
                            <div class="inputaffixed inputPrefixed">
                              <div class="inputfixture">
                                <span>+234</span>
                              </div>
                              <input
                                type="number"
                                id="us_phone"
                                maxlength="11"
                                min="0"
                                class="inputControl form-control"
                                placeholder="Enter Phone number"
                                required
                                v-model="formData.phoneNo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="labeledInputBlock">
                          <label
                            for="us_pass"
                            class="control-label color__default requiredField"
                          >Password</label>
                          <div class="input-group">
                            <input
                              type="password"
                              id="us_pass"
                              class="form-control user_pass"
                              placeholder="Create Password"
                              required
                              v-model="formData.password"
                            />
                            <span class="input-group-addon">
                              <button type="button" class id="showPass">
                                <i class="cust_icon icon_eye"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="auth_cta row">
                        <div class="primaryActionHolder col-md-5">
                          <submit-button
                            :loading="submitting"
                            :disabled="checkFields"
                            class="btn btn-block btn-secondary"
                          >
                            Get
                            Started
                          </submit-button>
                        </div>
                        <div class="disclaimer_block col-md-7">
                          <p class="font_md">
                            By creating an account, you agree
                            to our
                            <a
                              href="#"
                              class="btn-link"
                            >Terms</a> and
                            <a href="#" class="btn-link">Policies</a>.
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SignupOptions from "@/components/auth/SignupOptions";
import { mapActions } from "vuex";

export default {
  components: {
    SignupOptions
  },
  data() {
    return {
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        phoneNo: "",
        type: "off_taker",
        orgName: ""
      },
      submitting: false
    };
  },
  computed: {
    checkFields() {
      if (this.formData.firstName === "") {
        return true;
      }
      if (this.formData.lastName === "") {
        return true;
      }
      if (this.formData.password === "") {
        return true;
      }
      if (this.formData.email === "") {
        return true;
      }
      if (this.formData.phoneNo === "") {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(["createUser"]),
    signup() {
      this.submitting = true;
      this.createUser(this.formData)
        .then(response => {
          console.log("Register ", response);
          this.$router.push({
            name: "offtaker.accountSetupOne"
          });
        })
        .catch(error => {
          this.$toastr.error(error);
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style>
</style>
